import "core-js/modules/es.array.reduce";
import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export default function promisifyMsSubtleCrypto(backend) {
  var usages = ['decrypt', 'digest', 'encrypt', 'exportKey', 'generateKey', 'importKey', 'sign', 'verify'];

  var decorateUsage = function decorateUsage(fakeBackend, usage) {
    return decorate(backend, fakeBackend, usage);
  };

  return usages.reduce(decorateUsage, {});
}

function decorate(subtle, fakeBackend, name) {
  fakeBackend[name] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len,
        args,
        _key,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            return _context.abrupt("return", new Promise(function (resolve, reject) {
              // @ts-ignore
              var operation = subtle[name].apply(subtle, args);

              operation.oncomplete = function () {
                return resolve(operation.result);
              };

              operation.onerror = reject;
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return fakeBackend;
}